function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.26 42.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M42.79,2.24A9.63,9.63,0,0,0,34.88.16L27.52,1.5A7.66,7.66,0,0,0,23.13,4a7.72,7.72,0,0,0-4.4-2.48L11.37.16A9.64,9.64,0,0,0,.16,7.9,9.31,9.31,0,0,0,0,9.64v20.8a9.63,9.63,0,0,0,7.91,9.48L20,42.12a17,17,0,0,0,6.2,0l12.12-2.2a9.65,9.65,0,0,0,7.91-9.48V9.64A9.62,9.62,0,0,0,42.79,2.24ZM21.2,38.41l-.49-.08L8.6,36.13a5.79,5.79,0,0,1-4.75-5.69V9.64A5.78,5.78,0,0,1,9.64,3.86a6.09,6.09,0,0,1,1,.09L18,5.3A3.84,3.84,0,0,1,21.2,9.08Zm21.2-8a5.79,5.79,0,0,1-4.75,5.69l-12.11,2.2-.48.08V9.08a3.85,3.85,0,0,1,3.16-3.79l7.36-1.35a5.78,5.78,0,0,1,6.73,4.65,6.2,6.2,0,0,1,.09,1.05Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.e22e222d.svg";
export { ForwardRef as ReactComponent };